import findTourSagas from './findTourSaga';
import subscribeLocationSagas from './subscribeLocationSagas';

const sagas = [...findTourSagas, ...subscribeLocationSagas];

export default sagas;
